class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // The footer add-ons block renders empty and is hidden (display:none) until
    // filled — an IntersectionObserver would never fire on it, so load eagerly.
    // The main list stays lazy (loads when scrolled into view).
    if (this.dataset.key === 'footer') {
      this.loadRecommendations();
      return;
    }
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    this.loadRecommendations();
  }

  loadRecommendations() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        // Match the same block by key so multiple <cart-recommendations>
        // (e.g. main list + footer add-ons) don't pull each other's markup.
        const key = this.dataset.key;
        const selector = key
          ? `cart-recommendations[data-key="${key}"]`
          : 'cart-recommendations';
        const recommendations = html.querySelector(selector) || html.querySelector('cart-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        } else if (this.dataset.key === 'footer') {
          // No recommendations returned — keep the footer collapsed.
          this.style.display = 'none';
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
}
customElements.define('cart-recommendations', CartRecommendations);
